module.exports = __webpack_public_path__ + "media/bootstrap-icons/type-bold-32eebe76.svg";